import { injectable, inject, decorate } from 'inversify'
import { Api } from '@evertel/api'
import { makeAutoObservable, runInAction } from 'mobx'
import { DepartmentsAccessStore } from '@evertel/departments-access'


type UsersDetailData = { isPrimary: boolean, position: string }
class DepartmentUserController {

    constructor(
        private api: Api,
        private departmentsAccessStore: DepartmentsAccessStore
    ) {
        makeAutoObservable(this)
    }

    updateDetails = async (departmentId: number, userId: number, details: Partial<UsersDetailData>) => {
        // The auto-generated route body still declares dead fields (badgeNumber, assignment)
        // that the app no longer uses. Cast to the generated body type instead of
        // re-declaring those dead fields here.
        const updatedDepartmentAccess = await this.api.Routes.Department.putUsersDepartmentDetails(
            departmentId,
            userId,
            details as Parameters<Api['Routes']['Department']['putUsersDepartmentDetails']>[2]
        )

        runInAction(() => {
            this.departmentsAccessStore.update(updatedDepartmentAccess)
        })

        return updatedDepartmentAccess
    }

}

decorate(injectable(), DepartmentUserController)
decorate(inject(Api), DepartmentUserController, 0)
decorate(inject(DepartmentsAccessStore), DepartmentUserController, 1)

export { DepartmentUserController }
